import { IBaseDrugRna } from '@patsnap/synapse_common_interface'
import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { BDrugRnaFieldDesc } from '.'
import { getAsyncListTippyConfig } from '../card/config'

export const BDrugRnaPopperDesc = defineComponent({
  name: 'BDrugRnaPopperDesc',
  props: {
    data: {
      type: Object as PropType<IBaseDrugRna>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ data: this.data, popperEnable: true }} tippyConfig={getAsyncListTippyConfig()} component={BDrugRnaFieldDesc}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
